import React from 'react';
import { ui } from './ui';

// MCQ option grid (2 or 4 options) and Match-the-Column rows.
export default function OptionsEditor({ q, set }) {
  const setOpt = (i, v) => set({ options: q.options.map((o, k) => (k === i ? v : o)) });

  if (q.type === 'mcq') {
    const two = q.options.length === 2;
    const toggle = () => set({ options: two ? [...q.options, '', ''] : q.options.slice(0, 2) });
    return (
      <div style={{ marginTop: 6 }}>
        <div style={ui.row}>
          <span style={ui.label}>Options</span>
          <button type="button" style={ui.btn} onClick={toggle}>Switch to {two ? '4' : '2'} options</button>
        </div>
        <div style={ui.grid2}>
          {q.options.map((o, i) => (
            <input key={i} style={ui.input} value={o} placeholder={`Option ${String.fromCharCode(65 + i)}`} onChange={(e) => setOpt(i, e.target.value)} />
          ))}
        </div>
      </div>
    );
  }

  if (q.type === 'match') {
    const left = (o) => o.split('::')[0].trim();
    const right = (o) => (o.split('::')[1] || '').trim();
    return (
      <div style={{ marginTop: 6 }}>
        <span style={ui.label}>Rows (Column A | Column B)</span>
        {q.options.map((o, i) => (
          <div key={i} style={{ ...ui.row, marginBottom: 3, flexWrap: 'nowrap' }}>
            <input style={{ ...ui.input, flex: 1 }} value={left(o)} placeholder="Left" onChange={(e) => setOpt(i, `${e.target.value} :: ${right(o)}`)} />
            <input style={{ ...ui.input, flex: 1 }} value={right(o)} placeholder="Right" onChange={(e) => setOpt(i, `${left(o)} :: ${e.target.value}`)} />
            <button type="button" style={ui.btnDanger} onClick={() => set({ options: q.options.filter((_, k) => k !== i) })}>×</button>
          </div>
        ))}
        <button type="button" style={ui.btn} onClick={() => set({ options: [...q.options, ' :: '] })}>+ Row</button>
      </div>
    );
  }
  return null;
}
